/* eslint-disable */
import React from "react";
import { Row } from "reactstrap";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import EditIcon from "@material-ui/icons/Edit";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import SaveIcon from "@material-ui/icons/Save";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";

import {
  getAllRiskCriteriasConfigurations,
  getAllRiskCriterias,
  update_riskConfigurationCriteriaValues,
  add_criterias,
  delete_criterias,
  update_criteriaValue,
} from "../../utils/store/actions/risk.actions";
import {
  Box,
  Button,
  Input,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  withStyles,
} from "@material-ui/core";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { HStack, Circle, Heading, Image } from "@chakra-ui/react";

const useStyles = (theme: Theme) =>
  createStyles({
    root: {
      // width: "100%",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: "20%",
      flexShrink: 0,
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary,
      flexBasis: "40.33%",
    },
    paper: {
      width: "80%",
      backgroundColor: "#F5F6FF",
      margin: "7%",
      overflow: "hidden",
    },
    searchBar: {
      backgroundColor: "#F5F6FF",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
    searchInput: {
      backgroundColor: "#F5F6FF",
      fontSize: theme.typography.fontSize,
    },
    block: {
      display: "block",
    },
    addUser: {
      marginRight: theme.spacing(1),
    },
    contentWrapper: {
      margin: "40px 16px",
    },
    weight: {
      display: "flex",
      marginLeft: "10vh",
      fontSize: theme.typography.pxToRem(15),
      flexBasis: "33.33%",
      flexShrink: 0,
    },
    table: {
      height: "30vh",
    },
  });

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
class RiskCriterion extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      criteria: {
        criteriaConfigurationId: "",
        maximumScore: 0,
        minimumScore: 0,
        name: "",
      },
    };
  }

  componentDidMount() {
    this.props.getAllRiskCriteriasConfigurations();
    this.props.getAllRiskCriterias();
  }

  handleChange = (e: any, panel: string) => {
    this.setState({ extanded: e.target.isExpanded ? panel : false });
  };
  render() {
    const {
      classes,
      t,
      Risk: { risk_criterias, risk_criterias_configurations },
    } = this.props;
    return (
      <div>
        <Box
          style={{
            margin: "50px",
            display: "flex",
            alignItems: "top",
          }}
        >
          <HStack cursor="pointer">
            <Heading
              fontSize="18px"
              fontFamily="Inter, sans-serif"
              color="brand.bf3"
            >
              {t("RISK_PROFILE_CRITERIA_CONFIGURATION")}
            </Heading>
            <Image src="/icon/check-circle.svg" />
          </HStack>
        </Box>
        <Box
          style={{
            display: "flex",
            margin: "50px",
            flexDirection: "column",
          }}
        >
          <span>{t("CRITERIA_WEIGHT")}</span>
          <span>{t("CRITERIA_SCORING")}</span>
          <span>{t("CONFIGURATION_OF_RISK_PROFILE_VALUES")}</span>
        </Box>
        <Paper className={classes.paper}>
          <Row
            style={{
              display: "block",
              marginRight: "0px",
              marginLeft: "0px",
            }}
          >
            <div className={classes.root}>
              {risk_criterias_configurations?.content
                ?.sort((a: any, b: any) => b.weight - a.weight)
                .map((criteria: any, index: number) => {
                  return (
                    <Accordion key={criteria.id}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel1bh-content`}
                        id={`panel1bh-header`}
                      >
                        <Typography
                          style={{
                            fontSize: "14px",
                          }}
                          className={classes.heading}
                        >
                          {t("CRITERIA")} {index + 1} :
                        </Typography>
                        <Typography
                          style={{
                            fontSize: "14px",
                          }}
                          className={classes.secondaryHeading}
                        >
                          {this.props.t(criteria.criteria)[0].toUpperCase() +
                            this.props
                              .t(criteria.criteria)
                              .slice(1)
                              .toLowerCase()}
                        </Typography>
                        <Typography
                          className={classes.weight}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            fontSize: "14px",
                            alignItems: "center",
                          }}
                        >
                          {t("WEIGHT")}:{" "}
                          <Button
                            onClick={(event) => {
                              event.stopPropagation();
                              event.preventDefault();
                              this.props
                                .update_riskConfigurationCriteriaValues(
                                  criteria.weight - 1,
                                  criteria.id
                                )
                                .then(() =>
                                  this.props.getAllRiskCriteriasConfigurations()
                                );
                            }}
                          >
                            <RemoveCircleIcon style={{ color: "#ae0064" }} />
                          </Button>
                          <div style={{ color: "#ae0064", fontWeight: "bold" }}>
                            {criteria.weight}%
                          </div>
                          <Button
                            onClick={(event) => {
                              event.stopPropagation();
                              event.preventDefault();
                              this.props
                                .update_riskConfigurationCriteriaValues(
                                  criteria.weight + 1,
                                  criteria.id
                                )
                                .then(() =>
                                  this.props.getAllRiskCriteriasConfigurations()
                                );
                            }}
                          >
                            <AddCircleIcon style={{ color: "#ae0064" }} />
                          </Button>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <TableContainer
                          className={classes.table}
                          component={Paper}
                        >
                          <Table style={{ minWidth: "700" }} stickyHeader>
                            <TableHead>
                              <TableRow>
                                <TableCell></TableCell>
                                <TableCell align="center">
                                  Score Minimum
                                </TableCell>
                                <TableCell align="center"></TableCell>
                                <TableCell align="center">
                                  Score Maximum
                                </TableCell>
                                <TableCell align="center">
                                  {t("EDIT")}
                                </TableCell>
                                <TableCell align="center"></TableCell>
                                <TableCell align="center"></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {risk_criterias?.content.map(
                                (config: any) =>
                                  config.criteriaConfiguration.criteria ===
                                    criteria.criteria && (
                                    <TableRow>
                                      <TableCell align="center">
                                        {this.state[`edit_${config.id}`] ? (
                                          <Input
                                            value={this.state[config.id].name}
                                            onChange={(e) =>
                                              this.setState({
                                                [config.id]: {
                                                  ...this.state[config.id],
                                                  name: e.target.value,
                                                },
                                              })
                                            }
                                          />
                                        ) : (
                                          config.name
                                        )}
                                      </TableCell>
                                      <TableCell align="center">
                                        {this.state[`edit_${config.id}`] ? (
                                          <Input
                                            value={
                                              this.state[config.id].minimumScore
                                            }
                                            onChange={(e) =>
                                              this.setState({
                                                [config.id]: {
                                                  ...this.state[config.id],
                                                  minimumScore: e.target.value,
                                                },
                                              })
                                            }
                                          />
                                        ) : (
                                          config.minimumScore
                                        )}
                                      </TableCell>
                                      <TableCell align="center">
                                        {t("TO_DATE")}
                                      </TableCell>
                                      <TableCell align="center">
                                        {this.state[`edit_${config.id}`] ? (
                                          <Input
                                            value={
                                              this.state[config.id].maximumScore
                                            }
                                            onChange={(e) =>
                                              this.setState({
                                                [config.id]: {
                                                  ...this.state[config.id],
                                                  maximumScore: e.target.value,
                                                },
                                              })
                                            }
                                          />
                                        ) : (
                                          config.maximumScore
                                        )}
                                      </TableCell>
                                      <TableCell align="center">
                                        {this.state[`edit_${config.id}`] ? (
                                          <Button
                                            onClick={() => {
                                              this.props
                                                .update_criteriaValue(
                                                  this.state[config.id],
                                                  config.id
                                                )
                                                .then(() =>
                                                  this.props.getAllRiskCriterias()
                                                );
                                              this.setState({
                                                [`edit_${config.id}`]: !this
                                                  .state[`edit_${config.id}`],
                                              });
                                            }}
                                          >
                                            <SaveIcon />
                                          </Button>
                                        ) : (
                                          <Button
                                            onClick={() =>
                                              this.setState({
                                                [`edit_${config.id}`]: !this
                                                  .state[`edit_${config.id}`],
                                                [config.id]: {
                                                  ...this.state[config.id],
                                                  criteriaConfigurationId:
                                                    criteria.id,
                                                  name: config.name,
                                                  maximumScore:
                                                    config.maximumScore,
                                                  minimumScore:
                                                    config.minimumScore,
                                                },
                                              })
                                            }
                                          >
                                            <EditIcon />
                                          </Button>
                                        )}
                                      </TableCell>
                                      <TableCell align="center">
                                        {this.state[`edit_${config.id}`] && (
                                          <Button
                                            onClick={() =>
                                              this.props
                                                .delete_criterias(config.id)
                                                .then(() =>
                                                  this.props.getAllRiskCriterias()
                                                )
                                            }
                                          >
                                            <DeleteForeverIcon />
                                          </Button>
                                        )}
                                      </TableCell>
                                      <TableCell align="center">
                                        {this.state[`edit_${config.id}`] && (
                                          <Button
                                            onClick={() =>
                                              this.setState({
                                                [`edit_${config.id}`]: !this
                                                  .state[`edit_${config.id}`],
                                              })
                                            }
                                          >
                                            <HighlightOffIcon />
                                          </Button>
                                        )}
                                      </TableCell>
                                    </TableRow>
                                  )
                              )}
                              {this.state.add_criteria && (
                                <TableRow>
                                  <TableCell align="center">
                                    <Input
                                      value={this.state.criteria.name || ""}
                                      onChange={(e) =>
                                        this.setState({
                                          criteria: {
                                            ...this.state.criteria,
                                            name: e.target.value,
                                          },
                                        })
                                      }
                                      type="text"
                                      placeholder={t("NAME")}
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <Input
                                      value={
                                        this.state.criteria.minimumScore || ""
                                      }
                                      onChange={(e) =>
                                        this.setState({
                                          criteria: {
                                            ...this.state.criteria,
                                            minimumScore: e.target.value,
                                          },
                                        })
                                      }
                                      type="number"
                                      placeholder="score minimum"
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    {t("TO_DATE")}
                                  </TableCell>
                                  <TableCell align="center">
                                    <Input
                                      value={
                                        this.state.criteria.maximumScore || ""
                                      }
                                      onChange={(e) =>
                                        this.setState({
                                          criteria: {
                                            ...this.state.criteria,
                                            maximumScore: e.target.value,
                                          },
                                        })
                                      }
                                      type="number"
                                      placeholder="score maximum"
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    {/* <Button>
                                    <EditIcon />
                                  </Button> */}
                                  </TableCell>
                                  <TableCell align="center">
                                    <Button
                                      onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({ add_criteria: false });
                                        this.props
                                          .add_criterias(this.state.criteria)
                                          .then(() =>
                                            this.props.getAllRiskCriterias()
                                          );
                                      }}
                                    >
                                      {t("ADD")}
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              )}
                              <div>
                                <Button
                                  onClick={(e) =>
                                    this.setState({
                                      add_criteria: true,
                                      criteria: {
                                        ...this.state.criteria,
                                        criteriaConfigurationId: criteria.id,
                                      },
                                    })
                                  }
                                >
                                  <AddCircleIcon />
                                </Button>
                              </div>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
            </div>
          </Row>
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});

const mapDispatchToProps = {
  getAllRiskCriteriasConfigurations,
  getAllRiskCriterias,
  update_riskConfigurationCriteriaValues,
  add_criterias,
  delete_criterias,
  update_criteriaValue,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withTranslation()(RiskCriterion)));
